import styled from 'styled-components'

export const StatCardGroup = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 2rem 2rem;
`
export const StatCardValue = styled.div`
    font-family: "Encode Sans bold";
    font-size: 24px;
    padding: 6px 0;
    justify-content: center;
    text-align: center;

`
export const StatCardUnit = styled.div`
    font-family: "Encode Sans sbold";
    font-size: 14px;
    font-variant: small-caps;
    text-align: center;
`
export const StatCardIcon = styled.img`
    max-height: 32px;
    max-width: 43px;
`


